<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { defang } from '$lib/protocol/link-guard';
  import type { UnknownElement } from '$lib/protocol/types';

  let { element }: { element: UnknownElement } = $props();
</script>

<!-- An unknown type must not break the conversation: with independent server
     implementations and an evolving protocol, the client shows that something
     arrived and carries on. The spec requires fallback_text when present. -->
<p class="unknown">
  {element.fallbackText !== undefined ? defang(element.fallbackText) : t('el.unknown')}
</p>

<style>
  .unknown {
    margin: 0;
    font-style: italic;
    color: var(--ink-soft);
    white-space: pre-wrap;
  }
</style>
